import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-trigger-aktualisieren';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichTriggerAktualisierenEffects {

    BereichTriggerAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_TRIGGER_AKTUALISIEREN),
        mergeMap((x: ac.PostBereichTriggerAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichTriggerAktualisieren(x.bereichTriggerDatenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichTriggerAktualisierenErfolgreichAction(result, x.bereichTriggerDatenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichTriggerAktualisierenFehlerAction(error, x.bereichTriggerDatenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
